export enum CreditorEnum {
    DevelopmentAndAlumniRelationsOffice = "DARO",
    FellowsAndMembersOffice = "FMO"
}